import type { MenuCommand } from './desktop.js';
import { runCommand } from './shortcuts/index.js';
import { useWorkspace } from '../state/workspace.js';

/** Older native-menu ids, mapped onto shortcut-registry commands. */
const ALIASES: Record<string, string> = {
  'edit.quick-open': 'palette.open',
  'view.board': 'view.tab.board',
  'view.team': 'view.tab.team',
};

/**
 * Run a native menu command against this window's workspace. The tab host
 * forwards these into the visible project's frame, which runs them here.
 * Menu items carry shortcut-registry command ids, so a menu click and its key
 * binding always do the same thing.
 */
export function runWorkspaceMenuCommand(command: MenuCommand | string): void {
  const ws = useWorkspace.getState();
  switch (command) {
    case 'view.chat':
      // Show (never hide) the assistant.
      ws.setAiOpen(true);
      return;
    case 'edit.undo':
    case 'edit.redo':
      // In a text field the native text undo applies.
      if (isTextFocus()) {
        document.execCommand(command === 'edit.undo' ? 'undo' : 'redo');
        return;
      }
      break;
    default:
      break;
  }
  runCommand(ALIASES[command] ?? command);
}

function isTextFocus(): boolean {
  const el = document.activeElement as HTMLElement | null;
  if (!el) return false;
  return el.isContentEditable || el.tagName === 'TEXTAREA' || (el.tagName === 'INPUT' && !['checkbox', 'radio', 'button', 'range', 'color'].includes((el as HTMLInputElement).type));
}
